import React from "react";
import { currencyFormat, dateFormatNow, getServiciosProfecionales } from "../../util";
import { condicionVenta, medioPago } from "../../catalogos";
import RenderResumenDocumento from "../shared/RenderResumenDocumento";
import { Container } from 'semantic-ui-react';

export class ImprimirFactura extends React.PureComponent {

    constructor(props) {
        super(props);
        const { data, direccionEmisorState, direccionReceptorState } = props;
        this.state = {
            data: data,
            detalle: data.DetalleServicio.LineaDetalle,
            direccionEmisor: direccionEmisorState,
            direccionReceptor: direccionReceptorState,
            ResumenFactura: data.ResumenFactura
        };

    }

    componentDidUpdate() {
        const { direccionReceptorState } = this.props;
        if (this.state.data.Receptor?.Ubicacion) {
            this.setState(
                this.state.direccionReceptor = direccionReceptorState
            );
        }
    }

    getMedioPago = (value) => {
        if (value !== null) {
            return medioPago.filter((item) => item.value === value)[0].display;
        }
        return 'Verificar';
    };

    getCondicionVenta = (value) => {
        if (value !== null) {
            return condicionVenta.filter((item) => item.value === value)[0].display;
        }
        return 'Verificar';
    };

    getImpuesto = (impuestos = []) => {
        let monto = 0;
        impuestos.forEach((i) => {
            monto += i.Monto;
        });
        return (<span>{currencyFormat(monto)}</span>);
    }

    render() {

        return (
            <div>

                <div style={{ margin: "3vh" }} className="ui grid">

                    <div className="four column row">
                        <div className="left floated column"> {dateFormatNow(Date.now())} </div>
                        <div className="right floated column">Facturación en línea</div>
                    </div>

                    <div className="sixteen wide column">
                        <h3>Factura # {this.state.data.NumeroConsecutivo}  </h3>
                    </div>

                    <div className="sixteen wide column ui segment" style={{ paddingLeft: "2vh", marginTop: "-1vh" }}>
                        <div style={{ marginTop: "-1vh", marginBottom: "1vh" }}>
                            <h2>{this.state.data.Emisor.NombreComercial}</h2>
                        </div>
                        <div>
                            <strong>{this.state.data.Emisor.Nombre}</strong>
                        </div>
                        <div>
                            <strong>Cédula Jurídica:</strong> {this.state.data.Emisor.Identificacion.Numero}
                        </div>
                        <div>
                            {
                                this.state.data.Emisor.Telefono && <div>
                                    <strong>Teléfono: </strong>
                                    (+{this.state.data.Emisor.Telefono.CodigoPais}) {this.state.data.Emisor.Telefono.NumTelefono}
                                </div>
                            }
                        </div>
                        <div>
                            <strong>Correo: </strong> {this.state.data.Emisor.CorreoElectronico}
                        </div>
                        <div>
                            {
                                (this.state.direccionEmisor !== null) && <div>
                                    <strong>Dirección: </strong>
                                    {this.state.direccionEmisor?.NombreProvincia},&nbsp;
                                    {this.state.direccionEmisor?.NombreCanto}, &nbsp;
                                    {this.state.direccionEmisor?.NombreDistrito}, &nbsp;
                                    {this.state.direccionEmisor?.NombreBarrio}
                                </div>
                            }
                        </div>
                    </div>

                    <div className="sixteen wide column ui segment" style={{ paddingLeft: "2vh", marginTop: "-1vh" }}>
                        <div style={{ marginBottom: "1vh" }}>
                            <h3>Información del Cliente</h3>
                        </div>
                        <div>
                            <strong>Cliente: </strong> {this.state.data.Receptor?.Nombre}
                        </div>
                        <div>
                            <strong>Cédula: </strong> {this.state.data.Receptor?.Identificacion.Numero}
                        </div>
                        <div>
                            <strong>Correo: </strong> {this.state.data.Receptor?.CorreoElectronico}
                        </div>
                        <div>
                            {
                                this.state.data.Receptor?.Telefono && <div>
                                    <strong>Teléfono:</strong> (+{this.state.data.Receptor?.Telefono.CodigoPais}) {this.state.data.Receptor?.Telefono.NumTelefono}
                                </div>
                            }
                        </div>
                        <div>
                            {
                                (this.state.direccionReceptor?.NombreProvincia !== null) && <div>
                                    <strong>Dirección:</strong>&nbsp;
                                    {this.state.direccionReceptor?.NombreProvincia},&nbsp;
                                    {this.state.direccionReceptor?.NombreCanto}, &nbsp;
                                    {this.state.direccionReceptor?.NombreDistrito}, &nbsp;
                                    {this.state.direccionReceptor?.NombreBarrio}
                                </div>
                            }
                        </div>
                    </div>

                    <div className="sixteen wide column ui segment" style={{ paddingLeft: "2vh", marginTop: "-1vh" }}>
                        <div>
                            <strong>Clave Hacienda: </strong>  {this.state.data.Clave}
                        </div>
                        <div>
                            <strong>Fecha de Emision: </strong> {dateFormatNow(this.state.data.FechaEmision)}
                        </div>
                        <div>
                            <strong>Condicion de Venta:</strong> {this.getCondicionVenta(this.state.data.CondicionVenta)}
                        </div>
                        <div>
                            <strong>Medio de Pago:</strong> {this.getMedioPago(this.state.data.MedioPago)}
                        </div>
                    </div>

                    <div className="sixteen wide column">
                        <div style={{ marginBottom: "1vh" }}>
                            <h3>Detalle de Factura</h3>
                        </div>
                        <table className="ui very basic table">
                            <thead>
                                <tr>
                                    <th>Descripción</th>
                                    <th style={{ paddingLeft: "4vh", textAlign: "right" }} >Cantidad</th>
                                    <th style={{ paddingLeft: "4vh", textAlign: "right" }} >Precio</th>
                                    <th style={{ paddingLeft: "4vh", textAlign: "right" }} >Impuesto</th>
                                    <th style={{ paddingLeft: "4vh", textAlign: "right" }} >Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.detalle.map((item) => (
                                    <tr key={item.Detalle}>
                                        <td>
                                            {getServiciosProfecionales(item.UnidadMedida) ? "S" : "P"} - {item.Detalle}
                                        </td>
                                        <td style={{ textAlign: "right" }}><span style={{"white-space":"nowrap"}}>{item.Cantidad}</span></td>
                                        <td style={{ textAlign: "right" }}><span style={{"white-space":"nowrap"}}>{currencyFormat(item.PrecioUnitario)}</span></td>
                                        <td style={{ textAlign: "right" }}><span style={{"white-space":"nowrap"}}>{this.getImpuesto(item.Impuestos?.Impuesto)}</span></td>
                                        <td style={{ textAlign: "right" }}><span style={{"white-space":"nowrap"}}>{currencyFormat(item.MontoTotalLinea)}</span></td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>


                    <div className="ui row" style={{ alignContent: "flex-end" }}>

                        <div className="column nine wide">
                            <div>
                                <strong>Notas adicionales:</strong>
                            </div>
                            <div>
                            <p>La S. representa servicio, P. representa Producto</p>
                            <p>{this.state?.data?.Otros?.OtroTexto}</p>
                            </div>

                            <div style={{ marginTop: "20px" }} >
                                <strong>Autorizado mediante resolución MH-DGT-RES-0027-2024 Compatible con la versión 4.4</strong>
                            </div>
                            <div>
                                Facturación en línea: https://www.facturacion-enlinea.com
                            </div>
                        </div>
                        <div className="column seven wide right aligned" >
                            <RenderResumenDocumento ResumenFactura={this.state.ResumenFactura} />
                        </div>

                    </div>

                </div>

            </div>
        );
    }
}
